import { getActiveZones } from "./index23.js";
import { AggBuildingFromAnatomyNmcs } from "./index168.js";
import { RG_TYPE } from "@project-rouge/rg-core";
import { getRgObjectsOfType as getRgObjectsOfType$1 } from "@project-rouge/rg-three";
const pipeAggNmcs = ([parent, { aggProps, buildingIds }]) => {
	const dataset = aggProps.dataset;
	const zones = getActiveZones(parent, aggProps);
	for (const zone of zones) {
		const aggZoneProps = aggProps.zones[zone.uuid];
		const buildings = getRgObjectsOfType$1(zone, RG_TYPE.Building);
		for (const building of buildings) {
			if (buildingIds && !buildingIds.includes(building.uuid)) continue;
			AggBuildingFromAnatomyNmcs({
				building,
				aggZoneProps,
				dataset
			});
		}
	}
	return [parent, void 0];
};
export { pipeAggNmcs };

//# sourceMappingURL=index169.js.map